<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">
                <div class="lineWrapper amTealregular">EXHIBITIONS</div>
                <div v-for="(exhibit, index) in exhibits" :key="index">
                    <div class="exhibitList" @click="showDetail(exhibit)">
                        <div class="lineWrapper amTealregular">Exhibit ID: {{exhibit.id}}</div>
                        <div class="lineWrapper amGrayregular">{{exhibit.title}}</div>
                    </div>
                </div>
            </div>
            <div id="rightcolumn" class="cols">
            <div class="amMintregular">Edit Exhibition</div>
            <input class="textbox" type="text" placeholder="ID" v-model="id">
            <input class="textbox" type="text" placeholder="TITLE" v-model="title">
            <textarea class="textbox" type="text" placeholder="LEAD" v-model="lead"></textarea>
            <textarea class="textbox" type="text" placeholder="CAPTION" v-model="caption"></textarea>
            <textarea class="textbox" type="text" placeholder="RULES" v-model="rules"></textarea>
            <input class="textbox" type="text" placeholder="BG1" v-model="bg">
            <input class="textbox" type="text" placeholder="BG2" v-model="bg2">
            <select class="textbox" v-model="extype">
                <option value="null">EXHIBIT TYPE</option>
                <option value='exhibit'>exhibit</option>
                <option value='list'>list</option>
            </select>
            <select class="textbox" v-model="live">
                <option value="null">LIVE STAT</option>
                <option value='true'>TRUE</option>
                <option value='false'>FALSE</option>
            </select>
            <select class="textbox" v-model="onview">
                <option value="null">On View?</option>
                <option value='true'>TRUE</option>
                <option value='false'>FALSE</option>
            </select>
            <div class="btn" @click="saveUpdate">SAVE UPDATE</div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app";
import 'firebase/firestore'
import 'firebase/functions'
import db from '../main'
export default {
    name:'exhibits',
    data(){
        return {
            exhibits: [],
            exhibit: {},
            bg: "",
            bg2: " ",
            caption: "",
            lead: "",
            id:"",
            live:"",
            onview: "",
            title:"",
            extype: "",
            docid: "",
            rules:"",
        }
    },
    created(){
        db.collection('artmuseo').doc('_col').collection('collection').get().then(exhibitions => {
            if (exhibitions){
                exhibitions.forEach(document => {
                    const data = document.data()
                    this.exhibits.push(data)
                })
            }
        })
    },
    methods: {
        showDetail(exhibit){
            this.bg = exhibit.bg
            this.bg2 = exhibit.bg2
            this.caption = exhibit.caption
            this.lead = exhibit.lead
            this.live = exhibit.live
            this.onview = exhibit.onview
            this.title = exhibit.title
            this.id = exhibit.id
            this.extype = exhibit.type
            this.docid = exhibit.document_Id
            this.rules = exhibit.rules
        },
        saveUpdate(){
            const data = ({
            bg: this.bg,
            bg2: this.bg2,
            caption: this.caption,
            lead:this.lead,
            live:this.live,
            onview:this.onview,
            title:this.title,
            type:this.extype,
            rules:this.rules,
            document_Id: this.docid
            })

            const editex = firebase.functions().httpsCallable('editExhibit')
            return editex(data).then(success => {
                if (success){
                    alert('Edited Exhibited Successfully')
                }
            }).catch(err=> {
               if (err){
                   console.log('')
               }
            })
        },
    }
}
</script>

<style scoped>
#mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
}

.wrap {
    width: 100%;
    height: auto;
    margin-top: 2%;
    margin-bottom: 2%;
}

.exhibitList {
    width: 100%;
    height: auto;
    padding: 3%;
    background-color: aliceblue;
    border-radius: 1vmin;
    margin-bottom: 10px;
    float: left;
    clear: right;
    cursor: pointer;
}

.lineWrapper {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
}

.textbox {
    width: 100%;
    height: auto;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}

.textview {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}

</style>